import { SvgProps } from "components/icons/types";

export const BookAlt = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7430_448)">
      <path
        d="M13.3712 0.991648C13.1747 0.826991 12.9444 0.707735 12.6965 0.642393C12.4486 0.577051 12.1894 0.567236 11.9373 0.613648L8.33233 1.26873C7.81646 1.36175 7.34705 1.62605 7 2.0189C6.65321 1.6254 6.18377 1.36046 5.66767 1.26698L2.06267 0.611898C1.81053 0.566114 1.55142 0.576261 1.30364 0.641623C1.05585 0.706986 0.82545 0.825968 0.628706 0.990163C0.431962 1.15436 0.273678 1.35976 0.16504 1.59185C0.0564028 1.82394 6.22681e-05 2.07706 0 2.33332L0 12.1531L7 13.4266L14 12.1531V2.33332C14 2.07724 13.9437 1.8243 13.835 1.59244C13.7264 1.36057 13.568 1.15546 13.3712 0.991648V0.991648ZM6.41667 12.1333L1.16667 11.1801V2.33332C1.16674 2.24791 1.18556 2.16356 1.22181 2.08623C1.25806 2.0089 1.31085 1.94047 1.37645 1.88577C1.44204 1.83108 1.51885 1.79146 1.60144 1.76971C1.68403 1.74796 1.77039 1.74461 1.85442 1.7599L5.45883 2.41498C5.72765 2.46389 5.97077 2.60559 6.14581 2.81539C6.32085 3.02518 6.41671 3.28975 6.41667 3.56298V12.1333ZM12.8333 11.179L7.58333 12.1333V3.56298C7.58329 3.28975 7.67915 3.02518 7.85419 2.81539C8.02923 2.60559 8.27235 2.46389 8.54117 2.41498L12.1456 1.7599C12.2296 1.74461 12.316 1.74796 12.3986 1.76971C12.4811 1.79146 12.558 1.83108 12.6236 1.88577C12.6892 1.94047 12.7419 2.0089 12.7782 2.08623C12.8144 2.16356 12.8333 2.24791 12.8333 2.33332V11.179Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7430_448">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
